<section id="destinations" class="w-full pb-15">
    <!-- Header -->
    @if(view.page) {
    <!-- Header image with smooth flowing bottom -->
    <div class="relative w-screen h-[500px] overflow-hidden">
        <!-- Layer 1 -->
        <img [src]="view.imageLayer1" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 1" [class.opacity-100]="view.activeLayer === 1" />

        <!-- Layer 2 -->
        <img [src]="view.imageLayer2" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />
    </div>
    }
    <!-- <app-banner_section-type01 [options]="{ title: '', imageHref: view.packageImageUrl }"></app-banner_section-type01> -->

    @if(!view.eventsFiltered) {
    <div class="flex flex-col items-center justify-center mb-10 md:mt-5 lg:mt-10">
        <div class="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-primary-500"></div>
        <!-- <img src="https://www.svgrepo.com/show/509001/avatar-thinking-9.svg" class="rounded-full h-24 w-24"> -->
    </div>
    }

    @if(view.eventsFiltered) {
    <div class="flex flex-col items-center justify-center mb-10 md:mt-5 lg:mt-10">
        <div class="w-full flex justify-center items-center">
            @if(view.isClient){
            <div class="flex flex-col justify-center items-center mt-5 sm:pl-5 sm:pr-5 sm:items-center text">
                @if (view.site && view.site.profile && view.site.profile.heading) {
                @switch (view.site.profile.heading.position) {
                @case (1) {
                <app-heading_section-type01
                    [options]="{heading:'Our Events', title:'Making Every Event Simply Amazing', image:'', description:'', headingStyle: {'text-align': 'center'}, swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                }
                @case (2) {
                <app-heading_section-type01
                    [options]="{heading:'Our Services', title:'We Provide Top-Quality Solutions for You', image:'assets/xltravel/swoosh-01.svg', description:'', headingStyle: {'text-align': 'center'}, swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                }
                }
                }
            </div>
            }
        </div>
    </div>
    @if(view.isClient) {
    <p class="text-md md:text-lg text-gray-700 max-w-4xl mx-auto text-center mb-5 px-10"
        [innerHTML]="this.view.page?.content.rawContent"></p>
    }

    <div class="bg-white rounded-lg shadow-sm overflow-hidden m-8">
        <!-- Filter Section -->
        @if(!view.isClient) {
        <!-- Admin View Filters -->
        <div class="p-6">
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <!-- Type Filter Dropdown -->
                <div>
                    <label class="block text-md font-medium font-primary text-gray-700 mb-1">Event Types</label>
                    <select (change)="onDropdownChange('type', $event)"
                        class="w-full px-4 py-2 text-md border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                        <option value="">All Types</option>
                        <option *ngFor="let type of view.filter.events.options.types" [value]="type.name"
                            [selected]="view.filter.events.type === type.name">
                            {{ type.name }}
                        </option>
                    </select>
                </div>

                <!-- City Filter Dropdown -->
                <div>
                    <label class="block text-md font-medium font-primary text-gray-700 mb-1">Cities</label>
                    <select (change)="onDropdownChange('city', $event)"
                        class="w-full px-4 py-2 text-md border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                        <option value="">All Cities</option>
                        <option *ngFor="let city of view.filter.events.options.cities" [value]="city.name"
                            [selected]="view.filter.events.city === city.name">
                            {{ city.name }}
                        </option>
                    </select>
                </div>

                <!-- Start Date -->
                <div>
                    <label class="block text-md font-medium font-primary text-gray-700 mb-1">Start Date</label>
                    <input type="date" (change)="applyEventsFilter()"
                        class="w-full px-4 py-2 text-md border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        [(ngModel)]="view.filter.events.dateFrom" />
                </div>

                <!-- End Date -->
                <div>
                    <label class="block text-md font-medium font-primary text-gray-700 mb-1">End Date</label>
                    <input type="date" (change)="applyEventsFilter()"
                        class="w-full px-4 py-2 text-md border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        [(ngModel)]="view.filter.events.dateTo" />
                </div>
            </div>

            <!-- Search Input for Admin -->
            <div class="mb-4">
                <input type="text" [(ngModel)]="view.filter.events.text" (input)="applyEventsFilter()"
                    placeholder="Search events..."
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
            </div>

            <div class="flex items-end" matTooltip="Toggle ticket availability">
                <label class="inline-flex items-center cursor-pointer">
                    <input type="checkbox" [(ngModel)]="view.filter.events.hasTickets" (change)="applyEventsFilter()"
                        class="sr-only peer">
                    <mat-slide-toggle class="mt-8 sm:mt-0 sm:ml-auto" [color]="'primary'">
                        Has Tickets
                    </mat-slide-toggle>
                </label>
            </div>
        </div>
        }
        @if(view.isClient) {
        <!-- Client View Filters -->
        <div class="mb-6">
            <div class="bg-white p-4 rounded-lg shadow-sm">
                <!-- Search Input -->
                <div class="">
                    <input type="text" [(ngModel)]="searchQuery" (input)="filterEvents()" placeholder="Search events..."
                        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                </div>

                <!-- Category Filter -->
                <div class="mt-6">
                    <div class="flex flex-wrap gap-2">
                        <button (click)="clearCategories()"
                            class="px-6 py-2 text-sm rounded-full border border-gray-300 hover:bg-gray-100 transition-colors">
                            All
                        </button>
                        <button *ngFor="let category of uniqueCategories" (click)="toggleCategory(category)"
                            [class.bg-primary-500]="selectedCategory.includes(category)"
                            [class.text-white]="selectedCategory.includes(category)"
                            class="px-6 py-2 text-sm rounded-full border border-gray-300 hover:bg-blue-100 transition-colors">
                            {{category}}
                        </button>
                    </div>
                </div>

                <!-- Location Filter (optional) -->
                <div class="mt-4" *ngIf="false"> <!-- Set to *ngIf="true" to enable -->
                    <div class="flex flex-wrap gap-2">
                        <button (click)="clearLocations()"
                            class="px-6 py-2 text-sm rounded-full border border-gray-300 hover:bg-gray-100 transition-colors">
                            All Locations
                        </button>
                        <button *ngFor="let location of uniqueLocations" (click)="toggleLocation(location)"
                            [class.bg-primary-500]="selectedLocations.includes(location)"
                            [class.text-white]="selectedLocations.includes(location)"
                            class="px-6 py-2 text-sm rounded-full border border-gray-300 hover:bg-blue-100 transition-colors">
                            {{location}}
                        </button>
                    </div>
                </div>

                <!-- Price Range Filter (optional) -->
                <div class="mt-4" *ngIf="false"> <!-- Set to *ngIf="true" to enable -->
                    <div class="flex flex-wrap gap-2">
                        <button (click)="clearPriceRange()"
                            class="px-6 py-2 text-sm rounded-full border border-gray-300 hover:bg-gray-100 transition-colors">
                            All Prices
                        </button>
                        <button *ngFor="let range of priceRanges" (click)="togglePriceRange(range.value)"
                            [class.bg-primary-500]="selectedPriceRange === range.value"
                            [class.text-white]="selectedPriceRange === range.value"
                            class="px-6 py-2 text-sm rounded-full border border-gray-300 hover:bg-blue-100 transition-colors">
                            {{range.label}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>

    <!-- Events Listings -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">

        <!-- No Results Message -->
        @if((view.isClient && filteredEvents.length === 0) || (!view.isClient && view.eventsFiltered.length === 0)) {
        <div class="col-span-full text-center py-10">
            <div class="flex flex-col items-center justify-center">
                <img src="assets/images/no-results.svg" alt="No results found" class="w-32 h-32 mb-4">
                <h3 class="text-xl font-semibold text-gray-800 mb-2">No events found</h3>
                <p class="text-gray-600 max-w-md">Try adjusting your search or filter criteria</p>
                @if(view.isClient) {
                <button (click)="clearFilters()" class="mt-4 px-6 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors">
                    Clear Filters
                </button>
                }
            </div>
        </div>
        }
        @if(!view.isClient){
        <div *ngFor="let event of view.eventsFiltered" class="">
            <ng-container *ngTemplateOutlet="eventCardTemplate; context: {
                        item: event,
                    }">
            </ng-container>
        </div>
        }

        @if(view.isClient){
        <div *ngFor="let item of filteredEvents" class="mb-6">
            <ng-container *ngTemplateOutlet="eventCardTemplate; context: {
                        item: item,
                    }">
            </ng-container>
        </div>
        }
    </div>

    @if(view.isClient) {
    <div class="flex flex-col w-full justify-center items-center text-center mt-6">
        @if(view.totalFilteredCount > view.visibleEventsCount) {
        <button (click)="loadMore()"
            class="flex items-center font-semibold text-lg py-1 px-4 rounded-lg hover:bg-primary-500 border-2 border-accent-500 hover:border-primary-500 hover:text-white transition-all duration-300">
            Load More
        </button>
        }
        <p class="text-sm text-gray-600 text-center mt-4">
            {{ filteredEvents.length }} / {{view.totalFilteredCount}} {{ view.totalFilteredCount === 1 ? 'event' :
            'events' }} loaded
        </p>
    </div>
    }
    }
</section>

<ng-template let-bundle="bundle" #bundleTemplate>
    <!-- <app-property-1 *ngIf="site.layoutOptions?.topSeller == 1" [site]="site" [bundle]="bundle" [options]="{carousel:!(site?.id==54 || (site?.id==117 && !view.embed))}"></app-property-1>
<app-property-2 *ngIf="site.layoutOptions?.topSeller == 2" [site]="site" [bundle]="bundle"></app-property-2> -->
    <section *ngIf="bundle " class="product-slider">
        <ng-container *ngFor="let item of bundle">
            <ng-template carouselSlide *ngIf="item.supplier && item.supplier.image && item.supplier.image.imageUrl">
                <a [routerLink]="['/', tfmService.transform(item.destinationName), tfmService.transform(item.supplier.name)]"
                    class="block h-full">
                    <div
                        class="flex flex-col md:flex-row h-full rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                        <!-- Image Section -->
                        <div class="md:w-2/5 relative bg-cover bg-center"
                            [style.background-image]="'url(' + item.supplier.image.imageUrlBg + ')'"
                            [class.rounded-t-lg]="site?.layoutOptions?.border"
                            [class.rounded-l-lg]="site?.layoutOptions?.border"
                            [class.rounded-b-lg]="site?.layoutOptions?.border"
                            [class.md:rounded-tr-none]="site?.layoutOptions?.border"
                            [class.md:rounded-bl-none]="site?.layoutOptions?.border">
                            <div
                                class="absolute inset-0 bg-black bg-opacity-20 hover:bg-opacity-10 transition-all duration-300">
                            </div>
                        </div>

                        <!-- Content Section -->
                        <div class="md:w-3/5 bg-white p-4 flex flex-col justify-between"
                            [class.rounded-b-lg]="site?.layoutOptions?.border"
                            [class.rounded-r-lg]="site?.layoutOptions?.border"
                            [class.rounded-t-lg]="site?.layoutOptions?.border"
                            [class.md:rounded-tl-none]="site?.layoutOptions?.border"
                            [class.md:rounded-bl-none]="site?.layoutOptions?.border">
                            <!-- Icons -->
                            <div class="flex justify-center space-x-3 mb-3">
                                <ng-container *ngFor="let p of [].constructor(3);let i = index">
                                    <div *ngIf="(i == 0 && item.priceFlights > 0) || (i == 1 && item.priceTransfers > 0) || (i == 2 && item.priceAccommodation > 0)"
                                        class="w-8 h-8 rounded-full border-2 flex items-center justify-center"
                                        [style.color]="site?.colorPrimary2" [style.border-color]="site?.colorPrimary2">
                                        <i [class]="'fa ' + (i == 0 ? 'fa-plane' : (i == 1 ? 'fa-bus' : 'fa-bed'))"></i>
                                    </div>
                                </ng-container>
                            </div>

                            <!-- Title and Location -->
                            <div class="text-center">
                                <p class="text-sm font-medium uppercase tracking-wider"
                                    [style.color]="site?.colors?.primary2"
                                    [style.font-family]="site.layoutOptions?.fontFamilySecondary">
                                    {{item.supplier.place}}
                                </p>
                                <h3 class="text-lg font-bold truncate"
                                    [style.font-family]="site.layoutOptions?.fontFamilyPrimary">
                                    {{item.supplier.name}}
                                </h3>
                            </div>

                            <!-- Star Rating -->
                            <div class="flex justify-center mb-4"
                                ngbTooltip="{{item.supplier.grading}} star accommodation">
                                <div class="flex space-x-1">
                                    <i *ngFor="let p of [].constructor(item.supplier.grading);let i = index"
                                        class="fas fa-star text-yellow-400" [style.color]="site?.colorSecondary"></i>
                                </div>
                            </div>

                            <!-- Price -->
                            <div class="text-center">
                                <p class="text-sm font-medium mb-1" [style.color]="site?.colorSecondary">
                                    {{item.nights}} Nights
                                </p>
                                <p class="text-xl font-bold" [style.color]="site?.colorPrimary2"
                                    [style.font-family]="site.layoutOptions?.fontFamilySecondary">
                                    <span class="text-gray-500 text-sm font-normal">from </span>
                                    {{item.priceTotal | currency:(displayCurrencyCode || item.currency):'symbol-narrow'}}
                                    <span class="text-gray-500 text-xs font-normal" ngbTooltip="per person sharing"
                                        placement="bottom">pps</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </a>
            </ng-template>
        </ng-container>
    </section>

    <ng-container *ngIf="bundle && !options.carousel">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <ng-container *ngFor="let item of bundle">
                <ng-container *ngIf="item.supplier && item.supplier.image && item.supplier.image.imageUrl">
                    <a [routerLink]="['/', tfmService.transform(item.destinationName), tfmService.transform(item.supplier.name), item.id]"
                        class="block h-full">
                        <div
                            class="flex flex-col h-full rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                            <!-- Image Section -->
                            <div class="h-48 bg-cover bg-center"
                                [style.background-image]="'url(' + item.supplier.image.imageUrlBg + ')'"
                                [class.rounded-t-lg]="site?.layoutOptions?.border">
                                <div
                                    class="h-full w-full bg-black bg-opacity-20 hover:bg-opacity-10 transition-all duration-300">
                                </div>
                            </div>

                            <!-- Content Section -->
                            <div class="bg-white p-4 flex-grow flex flex-col justify-between"
                                [class.rounded-b-lg]="site?.layoutOptions?.border">
                                <!-- Icons -->
                                <div class="flex justify-center space-x-3 mb-3">
                                    <ng-container *ngFor="let p of [].constructor(3);let i = index">
                                        <div *ngIf="(i == 0 && item.priceFlights > 0) || (i == 1 && item.priceTransfers > 0) || (i == 2 && item.priceAccommodation > 0)"
                                            class="w-8 h-8 rounded-full border-2 flex items-center justify-center"
                                            [style.color]="site?.colorPrimary2"
                                            [style.border-color]="site?.colorPrimary2">
                                            <i
                                                [class]="'fa ' + (i == 0 ? 'fa-plane' : (i == 1 ? 'fa-bus' : 'fa-bed'))"></i>
                                        </div>
                                    </ng-container>
                                </div>

                                <!-- Title and Location -->
                                <div class="text-center mb-3">
                                    <p class="text-sm font-medium uppercase tracking-wider mb-1"
                                        [style.color]="site?.colors?.primary2"
                                        [style.font-family]="site.layoutOptions?.fontFamilySecondary">
                                        {{item.supplier.place}}
                                    </p>
                                    <h3 class="text-lg font-bold truncate"
                                        [style.font-family]="site.layoutOptions?.fontFamilyPrimary">
                                        {{item.supplier.name}}
                                    </h3>
                                </div>

                                <!-- Star Rating -->
                                <div class="flex justify-center mb-4"
                                    ngbTooltip="{{item.supplier.grading}} star accommodation">
                                    <div class="flex space-x-1">
                                        <i *ngFor="let p of [].constructor(item.supplier.grading);let i = index"
                                            class="fas fa-star text-yellow-400"
                                            [style.color]="site?.colorSecondary"></i>
                                    </div>
                                </div>

                                <!-- Price -->
                                <div class="text-center">
                                    <p class="text-sm font-medium mb-1" [style.color]="site?.colorSecondary">
                                        {{item.nights}} Nights
                                    </p>
                                    <p class="text-xl font-bold" [style.color]="site?.colorPrimary2"
                                        [style.font-family]="site.layoutOptions?.fontFamilySecondary">
                                        <span class="text-gray-500 text-sm font-normal">from </span>
                                        {{item.priceTotal | currency:(displayCurrencyCode || item.currency):'symbol-narrow'}}
                                        <span class="text-gray-500 text-xs font-normal" ngbTooltip="per person sharing"
                                            placement="bottom">pps</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-template>
<ng-template #eventCardTemplate let-item="item">
    <!-- Event Card -->
    <div
        class="bg-white rounded-lg shadow-md hover:shadow-lg overflow-hidden transition-all duration-300 h-full flex flex-col border border-gray-100">
        <!-- Image -->
        <div class="relative aspect-[4/3] overflow-hidden">
            <img [src]="item.supplier?.images.rawImageUrl || fallbackImg"
                class="absolute inset-0 w-full h-full object-fill p-1" alt="event image" />
        </div>
        <!-- Content -->
        <div class="p-4 flex-1 flex flex-col">
            <!-- Location -->
            <div class="flex items-center mb-3">
                <mat-icon class="icon-size-4 text-gray-500 mr-1">location_on</mat-icon>
                <div class="text-sm font-medium text-blue-600">
                    {{item.supplier?.place}}
                </div>
            </div>

            <!-- Title -->
            <p class="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
                {{item.supplier?.name}}
            </p>

            <!-- Short Content -->
            <div class="text-sm text-gray-600 mb-3 line-clamp-3" [innerHTML]="item.supplier?.contentShort"></div>

            <!-- Price -->
            <div class="mt-auto pt-2 border-t border-gray-100">
                <div class="flex items-end justify-between">
                    <div>
                        <span class="text-xs text-gray-500 block">From</span>
                        <div class="text-xl font-bold text-primary-500">
                            {{item.priceAdvertise | currency:(displayCurrencyCode || item.currency):'symbol-narrow'}}
                        </div>
                    </div>
                    <!-- Date and Time -->
                    <div class="flex items-center space-x-2 text-gray-600">
                        <mat-icon class="text-gray-500"
                            style="width: 20px; height: 20px; font-size: 20px;">event</mat-icon>
                        <span class="text-sm">
                            {{item.date | date:'mediumDate'}} • {{item.date | date:'shortTime'}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="px-5 py-3 bg-gray-50 border-t border-gray-100 flex justify-between">
            <div class="flex items-center mt-1 space-x-2">
                <span
                    class="px-3 py-1 text-xs font-semibold bg-blue-100 text-primary-800 rounded-full">{{item.category}}</span>
            </div>
            @if(view.isClient){
            <button mat-stroked-button color="primary" (click)="enquireEvent(item)"
                class="flex items-center py-1 px-4 rounded-lg hover:bg-primary-500 border-2 border-accent-500 hover:border-primary-500 hover:text-white transition-all duration-300">
                Enquire
            </button>
            }
        </div>
    </div>
</ng-template>